const API = "api";
const formatBaseUrl = (protocol, hostname, port) => {
  return protocol + "//" + hostname + (port ? ":" + port : "");
};

export const isLocal = window.location.hostname === "localhost";

const inferred = (() => {
  const hostnameParts = window.location.hostname.split(".");
  let mode = "admin";
  const matched = hostnameParts[0].match(/^(?<env>[^-]+)-(?<mode>[^-]+)$/);
  if (matched && matched?.groups) {
    mode = matched.groups.mode;
    hostnameParts[0] = `${matched.groups.env}-${API}`;
  } else if (hostnameParts.length > 2) {
    mode = hostnameParts[0].toLowerCase();
    hostnameParts[0] = API;
  } else {
    hostnameParts.unshift(API);
  }
  const serverHost = hostnameParts.join(".");
  const solServerHost = serverHost.replace(/^([^.]+)/, '$1-sol');
  return { mode, serverHost, solServerHost };
})();

export const SERVER_BASE_URL =
  (isLocal
    ? formatBaseUrl(window.location.protocol, "localhost", 8000)
    : formatBaseUrl(window.location.protocol, inferred.serverHost)); // Temporarily switching dev server for testing

export const SOL_SERVER_BASE_URL =
  (isLocal
    ? formatBaseUrl(window.location.protocol, "localhost", 8001)
    : formatBaseUrl(window.location.protocol, inferred.solServerHost)); // Temporarily switching dev server for testing

export const CLIENT_BASE_URL = formatBaseUrl(window.location.protocol, window.location.hostname, window.location.port ? parseInt(window.location.port) : undefined);

export const GOOGLE_CLIENT_ID = "874354046897-fngq8nee4s9aula5l8bap7cgbqvp8n8f.apps.googleusercontent.com";

export const createAdminUrl = () => CLIENT_BASE_URL === "https://agendav2.swivu.com" ? "https://swivu.com" : CLIENT_BASE_URL.replace("agendav2", "admin");

export const createAgendaUrl = () => CLIENT_BASE_URL === "https://hq.swivu.com" ? "https://workforce.swivu.com" : CLIENT_BASE_URL.replace("admin", "workforce")

export const WEBSOCKET_ACTION_KEY = isLocal ? "type" : "action";

export const ENABLE_WEBSOCKET = true;

const WEB_SOCKET_ENV_KEY_CONFIG = {
  dev: 'websocket.dev.swivu.com',
  staging: 'websocket.staging.swivu.com',
  swivu: 'websocket.swivu.com' // Production
}

export const isTestEnv = SERVER_BASE_URL.includes("-api.swivu.com");

export const WEB_SOCKET_URL_KEY = isTestEnv ?
  SERVER_BASE_URL.replace("api", "websocket").replace("https://", "") :
  WEB_SOCKET_ENV_KEY_CONFIG[SERVER_BASE_URL.split(".")[1]];
